import { dividePathByTimeGap, Path } from "@/components/Map/PathMap";
import { Services } from "@/services/services";
import { SearchCriteria, SearchCriteriaParams } from "@/pages/communal/statistics/components/common/searchCriteria";

export const MAP_COLORS: string[] = [
    "#1f77b4", // blue
    "#ff7f0e", // orange
    "#2ca02c", // green
    "#d62728", // red
    "#9467bd", // purple
    "#8c564b", // brown
    "#e377c2", // pink
    "#7f7f7f", // gray
    "#bcbd22", // yellow-green
    "#17becf", // cyan
    "#a55194", // plum
    "#393b79", // dark blue
    "#637939", // olive
    "#8c6d31", // ochre
    "#843c39", // maroon
    "#5254a3"  // steel blue
];

const defaultColor = "#5254a3"

export type MachineType = {
    manufacturer: string;
    category: string;
    model: string;
};

export type UserDeviceHistory = {
    name: string | null
    serialNumber: string | null
    internalNumber: string | null
    type: MachineType | null
    imei: string
    path: Path
    dividedPaths?: Path[]
    userId: string
};

export type UserDeviceHistories = {
    [sessionId: string]: UserDeviceHistory;
};

export type HistoryUser = {
    username: string
    email: string
    id: string
    color?: string | undefined
};

export type PathResponse = {
    history: UserDeviceHistories
    users: HistoryUser[]
};

export type UserDeviceHistoriesMachine = {
    name: string | null
    serialNumber: string | null
    internalNumber: string | null
    type: MachineType | null
    color: string
    imei: string
};

export type UserDeviceHistoriesMachines = {
    [sessionId: string]: UserDeviceHistoriesMachine;
};


export type UserDeviceHistoriesData = {
    hash: string
    histories: UserDeviceHistories
    users: HistoryUser[]
    machines: UserDeviceHistoriesMachines
};

function getMachines(data: UserDeviceHistories): UserDeviceHistoriesMachines {
    let machineCounter = 0
    const machines: UserDeviceHistoriesMachines = {}
    const orderedKeys = Object.keys(data).sort();
    for (let i = 0; i < orderedKeys.length; i++) {
        const row = data[orderedKeys[i]]
        if (machines[row.imei]) {
            continue
        }
        let machine: UserDeviceHistoriesMachine = {
            imei: row.imei,
            internalNumber: row.internalNumber,
            name: row.name,
            serialNumber: row.serialNumber,
            type: row.type,
            color: MAP_COLORS[machineCounter % MAP_COLORS.length]
        }
        machines[row.imei] = machine
        machineCounter++
    }
    return machines
}

function extendUsers(data: HistoryUser[]): HistoryUser[] {
    let users = [...data]
    for (let i = 0; i < users.length; i++) {
        users[i].color = MAP_COLORS[i % MAP_COLORS.length]
    }
    return users
}

export function divideMapData(data: UserDeviceHistories) {
    if (data === undefined) {
        return
    }
    const orderedKeys = Object.keys(data).sort();
    for (let i = 0; i < orderedKeys.length; i++) {
        const row = data[orderedKeys[i]]
        row.dividedPaths = dividePathByTimeGap(row.path)
    }
}


export function sendHistoriesRequest(services: Services, criteria: SearchCriteria): Promise<UserDeviceHistoriesData> {
    return services.session
        .fetchWithToken(`/api/communal/statistics/path?${SearchCriteriaParams(criteria)}`)
        .then((r) => r.json())
        .then((response: PathResponse) => {
            divideMapData(response.history)
            const machines = getMachines(response.history)
            return {
                hash: Date.now().toString(),
                histories: response.history,
                users: extendUsers(response.users),
                machines
            }
        })
}